import {useCallback} from 'react';
import {forbidExtraProps} from 'airbnb-prop-types';
import {any, object} from 'prop-types';
import {FetchApiContext, ProfileContext} from 'r/contexts';
import {unionContexts, explicitNullOr} from 'r/utils';
import {fetchApiRaw} from 'r/utils/fetchApiRaw';
import {keccak256} from 'viem';


export default unionContexts(
  FetchApiProvider,
  [
    ProfileContext,
    'profile',
  ],
);

FetchApiProvider.propTypes = forbidExtraProps({
  children: any.isRequired,
  profile: explicitNullOr(object),
});

function FetchApiProvider({
  children,
  profile,
}) {
  const fetchApi = useCallback(
    (endpointId, options) => fetchApiRaw(endpointId, options, profile?.accessToken),
    [profile?.accessToken],
  );
  fetchApi.id = keccak256(profile?.id ?? '');

  const value = {
    fetchApi,
  };

  window.__r__debugFetchApiContextValue = value; // eslint-disable-line no-restricted-syntax

  return (
    <FetchApiContext.Provider value={value}>
      {children}
    </FetchApiContext.Provider>
  );
}
